<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'kysDetailDialog',
  mixins: [snackbarMixin],
  props: {
    isCreateMode: {
      type: Boolean,
    },
    item: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      visible: false,
      hasError: false,
      formData: {},
      files: [],
      baseUrl: 'https://onayapi.summa.com.tr:8098/', // temel URL
      statusList: [],
    };
  },
  computed: {
    ...mapState({
      isKysAdmin: state => state.isKysAdmin
    }),
    isAnyQuestionYes() {
      return (
        this.formData.isLimitUstuTutar ||
        this.formData.isYuksekRiskliUlke ||
        this.formData.isYuksekRiskliUrun ||
        this.formData.isDevletIliskili
      );
    },
  },
  created() {
    if (!this.isCreateMode) {
      this.formData = Object.assign({}, this.item);
    } else {
      this.formData = {};
    }
  },
  mounted() {
    this.visible = true;
    this.fetchDropdownData();
    this.initializeData();
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('kysFormu',['getDetail', 'getStatusList']),
    ...mapMutations('kysFormu', ['getList']),
    fetchData() {
    },
    initializeData() {
    },
    getFileName(filePath) {
      // Dosya yolunu "/" ile bölelim ve son parçayı (dosya adını) döndürelim
      const pathSegments = filePath.split('/');
      return pathSegments[pathSegments.length - 1];  // Son parçayı alıyoruz, yani dosya adını
  } ,
    async submit() {
      this.hasError = false;

      if(this.formData.tedarikciUnvani === undefined || this.formData.tedarikciUnvani == ""){
        this.hasError = true;
      }
      if(this.formData.isLimitUstuTutar == undefined ||
        this.formData.isYuksekRiskliUrun  == undefined ||
        this.formData.isYuksekRiskliUlke  == undefined ||
        this.formData.isDevletIliskili  == undefined
       ){
        this.hasError = true;
       } 
      
       if(this.hasError){
        return;
       }

       if (this.files.length > 0 && this.isAnyQuestionYes) {
          const formData = new FormData();
          formData.append('kysFormu', JSON.stringify(this.formData));

          // Birden fazla dosya yükleniyorsa, hepsini FormData'ya ekliyoruz
          this.files.forEach((file, index) => {
            formData.append(`fileDetails[${index}].FileDetails`, file);  // formFiles[0], formFiles[1] şeklinde ekliyoruz
            formData.append(`fileDetails[${index}].FileType`, '2');  // formFiles[0], formFiles[1] şeklinde ekliyoruz
          });

        var response = await this.$store.dispatch('kysFormu/saveWithFile', formData);
        if (response.status === 200 && response.data > 0) {
          this.showSuccessMessage('Form kaydedildi');
          this.fetchData();
          this.$emit('close');
        } else {
          this.hasError = true;
          this.showErrorMessage(response.data);
        }
      }
      else{
      this.$emit('save', this.formData);
      }

    },
    async handleFileUpload(files) {
      this.files = files;
    },
    close() {
      this.$emit('close');
    },
    deleteKys(){
      this.$emit('delete', this.formData.id);
    },
    fetchDropdownData() {
      this.isLoading = true;
      const promises = [
        this.getStatusList()
          .then((res) => {
            this.statusList = res.data;
          }),
      ];
      Promise.all(promises).then(() => {
        this.isLoading = false;
      }).catch(() => {
        this.hasError = true;
      });
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="1200px">
    <v-card>
      <v-card-title>
        {{ $t('kysFormList') }}
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex xs6 md1 py-0>
              <v-text-field
                v-model="formData.id"
                :label="$t('code')"
                height="22"
                class="caption"
                readonly
              />
            </v-flex>
            <v-flex xs12 md3 py-0>
              <v-text-field
                v-model="formData.olusturanKullanici"
                :label="$t('createdBy')"
                height="22"
                class="caption"
                readonly
              />
            </v-flex>
            <v-flex xs12 md2 py-0>
              <v-text-field
                v-model="formData.olusturmaTarihi"
                :label="$t('createDate')"
                height="22"
                class="caption"
                readonly
                dateWithTimeView
              />
            </v-flex>
            <v-flex xs12 md3 py-0>
              <v-text-field
                v-model="formData.guncelleyenKullanici"
                :label="$t('modifiedBy')"
                height="22"
                class="caption"
                readonly
              />
            </v-flex>
            <v-flex xs12 md2 py-0>
              <v-text-field
                v-model="formData.guncellemeTarihi"
                :label="$t('modifiedDate')"
                height="22"
                class="caption"
                readonly
                dateWithTimeView
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.tedarikciUnvani"
                :label="$t('vendorName')"
                height="22"
                class="caption"
                required
                :rules="[v => !!v || 'Tedarikçi ünvanı zorunlu bir alandır']"
              >
                <template v-slot:label>
                  {{ $t('vendorName') }} <span style="color: red;">*</span>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.vergiNo"
                :label="$t('identityOrPassportNumber')"
                height="22"
                class="caption"
                required
                :rules="[v => !!v || 'Vergi / Kimlik No zorunlu bir alandır']"
              >
                <template v-slot:label>
                  {{ $t('identityOrPassportNumber') }} <span style="color: red;">*</span>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md12 py-0>
              <v-radio-group v-model="formData.isLimitUstuTutar"  :label="$t('kysQuestion1')" required>
                <v-radio :label="$t('yes')" :value="true"></v-radio>
                <v-radio :label="$t('no')" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex xs12 md12 py-0>
              <v-radio-group v-model="formData.isYuksekRiskliUlke" :label="$t('kysQuestion2')">
                <v-radio :label="$t('yes')" :value="true"></v-radio>
                <v-radio :label="$t('no')" :value="false"></v-radio>
            </v-radio-group>
            </v-flex>

            <v-flex xs12 md12 py-0>
              <v-radio-group v-model="formData.isYuksekRiskliUrun" :label="$t('kysQuestion3')">
                <v-radio :label="$t('yes')" :value="true"></v-radio>
                <v-radio :label="$t('no')" :value="false"></v-radio>
            </v-radio-group>
            </v-flex>

            <v-flex xs12 md12 py-0>
              <v-radio-group v-model="formData.isDevletIliskili" :label="$t('kysQuestion4')">
                <v-radio :label="$t('yes')" :value="true"></v-radio>
                <v-radio :label="$t('no')" :value="false"></v-radio>
            </v-radio-group>
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-autocomplete
                  v-model="formData.kysStatusId"
                  item-text="statu"
                  item-value="id"
                  :items="[
                    { id: 1, statu: $t('kysStatus1')},
                    { id: 2, statu: $t('kysStatus2') },
                    { id: 3, statu: $t('kysStatus3') },
                    { id: 4, statu: $t('kysStatus4') }
                  ]"
                  label="Statu"
                  class="caption"
                  dense
                  clearable
                  :disabled="!isKysAdmin"
              />
            </v-flex>


            <v-flex xs12 md12 py-0 v-if="isAnyQuestionYes">
              {{ $t('kysWarningMessage') }}
              <br/>
              {{ $t('kysFileDefaultDownloadUrl') }} <a href="https://onay.summa.com.tr/kys/kys.docx">{{ $t('click') }}</a>.<br/>
              {{ $t('kysFileDefaultDownloadUrl_en') }} <a href="https://onay.summa.com.tr/kys/kys_eng.docx">{{ $t('click') }}</a>.<br/>
              <v-flex xs12 md12 pf-0>
                <v-file-input
                    v-model="files"
                    :label="$t('uploadKysForm')"
                    accept=".doc, .docx, .pdf"
                    multiple                 
                    @change="handleFileUpload"
                  ></v-file-input>
              </v-flex>
            </v-flex>
          <v-flex xs12 md12 py-0 v-if="formData.kysDocuments && formData.kysDocuments.length > 0">
            <div v-for="(document, index) in formData.kysDocuments" :key="index" class="d-flex align-center">
              <!-- Yüklenen KYS Formu -->
              <v-flex xs7 md7 py-0 class="d-flex align-center">
                {{ $t('uploadedKysForm') }}: &nbsp;<strong>{{ getFileName(document.path) }}</strong> &nbsp;&nbsp&nbsp;&nbsp;
                <a :href="`${baseUrl}${document.path}`" target="_blank">
                  {{ $t('click') }}
                </a>
              </v-flex>
              
              <!-- Yükleyen -->
              <v-flex xs3 md3 py-0 class="d-flex align-center">
                <v-text-field
                  v-model="document.createdBy"
                  :label="$t('uploadedBy')"
                  height="22"
                  class="caption"
                  readonly
                />
              </v-flex>
              
              <!-- Yükleme Tarihi -->
              <v-flex xs2 md2 py-0 class="d-flex align-center">
                <v-text-field
                  v-model="document.createdDate"
                  :label="$t('uploadDate')"
                  height="22"
                  class="caption"
                  readonly
                  dateWithTimeView
                />
              </v-flex>
            </div>
          </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>


      <v-card-actions>
        <span v-if="hasError" style="color: red;">Lütfen sorulara cevap veriniz!</span>
        <v-spacer />
        <v-btn color="red lighten-3" dark @click="close">
          {{ $t('close') }}
        </v-btn>
        <v-btn color="red lighten-3" dark @click="deleteKys" v-if="isKysAdmin">
          {{ $t('delete') }}
        </v-btn>
        <v-btn color="success" @click="submit">
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
